// extracted by mini-css-extract-plugin
export default {"container":"WSInfoBanner-module_container-itpk1","header":"WSInfoBanner-module_header-fmFFa","childrenContainer":"WSInfoBanner-module_childrenContainer-lj6Aq"};